/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.alarmRules', [])
    .factory('alarmRulesService', AlarmRulesService)
    .name;

/*@ngInject*/
function AlarmRulesService($http, $q) {

    var service = {
        getNotificationRefs: getNotificationRefs
    };

    return service;

    function getNotificationRefs () {
        var deferred = $q.defer();
        var url = '/api/alarmRules/notificationRefs';
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/alarm-rules.service.js